module.exports = __webpack_public_path__ + "img/tid.32886a34.png";